import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { teamService } from '../../../Services';
import { teamActions } from '../../../Actions';

const List = () => {
  const auth = useSelector((state) => state.auth);
  const team = useSelector((state) => state.team);
  const user = auth.user;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    teamService.list().then(res => {
      if(res.status == 401) {
        navigate("/logout");
      }
      let team = res.data.list;
      localStorage.setItem("team", JSON.stringify(team));
      dispatch(teamActions.team(team));
    });
  }, []);
  return (
    <>
      <div className='card border-info'>
        <div className="card-header bg-light p-2 border-info" style={{"borderTop": "3px solid"}}><h6>Fellowship Team</h6></div>
        <div className='card-body'>
          <table className='table table-borderless'>
            <tbody>
              <tr>
                <td width={"30%"}>Name of Lead/ Principal Investigator</td>
                <td>:</td>
                <td>{user.fullname}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>:</td>
                <td>{user.username}</td>
              </tr>
              <tr>
                <td>Phone</td>
                <td>:</td>
                <td>{user.phone}</td>
              </tr>
            </tbody>
          </table>
          <table className='table'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Gender</th>
                <th>Country</th>
                <th className='text-center'>Action</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(team).length>0 && team.map((val, key) => {
                return (
                  <tr key={key}>
                    <td>{val.name}</td>
                    <td>{val.email}</td>
                    <td>{val.phone}</td>
                    <td>{val.gender}</td>
                    <td>{val.country_name}</td>
                    <td className='text-center'>
                      <Link to={"/user/team/edit"} state={{team_id: val.id}} title="Edit team member">
                        <FontAwesomeIcon icon={faEdit} />
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default List;